/**
 * Далеко ли человек от площадки — чистая функция над bbox, с запасом на
 * GPS-шум у самой границы. Порт правила `outsideVenue()` из
 * web/src/travel-choice.ts (там — без запаса, для выбора вида транспорта);
 * здесь запас нужен `resolveStart()`, чтобы не брать гео за пределами
 * площадки стартом маршрута (см. карточку «Вы далеко от площадки»).
 */
import type { LonLat } from '@app/geo'
import type { Venue } from './types'

/** Запас за пределами bbox площадки, чтобы решение не мигало на границе. */
export const FAR_FROM_VENUE_MARGIN_M = 150

/** Метров в одном градусе широты — величина не зависит от широты. */
const METERS_PER_DEG_LAT = 111320

/**
 * true — координата [geo] вне площадки [venue] с запасом
 * [FAR_FROM_VENUE_MARGIN_M]; отсутствие координаты — не «далеко», а
 * «неизвестно», решать молчаливым «нет» безопаснее, чем ложной тревогой.
 */
export function farFromVenue(venue: Venue, geo: LonLat | null | undefined): boolean {
  if (!geo) return false
  const [w, s, e, n] = venue.venue.bbox
  const midLat = (s + n) / 2
  const marginLat = FAR_FROM_VENUE_MARGIN_M / METERS_PER_DEG_LAT
  const metersPerDegLon = METERS_PER_DEG_LAT * Math.cos((midLat * Math.PI) / 180)
  const marginLon = metersPerDegLon <= 0 ? marginLat : FAR_FROM_VENUE_MARGIN_M / metersPerDegLon

  const [lon, lat] = geo
  return lon < w - marginLon || lon > e + marginLon || lat < s - marginLat || lat > n + marginLat
}
